import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function Dashboard() {
  const navigate = useNavigate();

  const startExam = (mode) => {
    localStorage.setItem("examMode", mode);
    localStorage.setItem("currentPaper", 1);
    navigate("/exam-select");
  };

  return (
    <div className="min-h-screen bg-[var(--bg)] text-[var(--text)] flex flex-col" style={{ fontFamily: "'Manrope', system-ui, sans-serif" }}>
      {/* Nav */}
      <nav className="border-b border-[var(--border-ui)] px-6">
        <div className="py-3.5 flex items-center justify-between">
          <button onClick={() => navigate("/practice")} className="brand-btn">
            tmua<span className="brand-prep">prep</span>
          </button>
        </div>
      </nav>

      <main className="paper-grid flex-1 flex items-center justify-center px-6 py-20">
        <div className="max-w-md w-full">
          <div className="eyebrow text-[#60a5fa] mb-4">Practice Mode</div>
          <h1 className="font-display text-4xl tracking-tight mb-2">Choose your mode</h1>
          <p className="text-[var(--muted-text)] text-sm mb-10">Select how you'd like to take the test.</p>

          <div className="space-y-3">
            <button
              onClick={() => startExam("timed")}
              className="group w-full flex items-center justify-between px-6 py-5 bg-[var(--surface-raised)] hover:bg-[var(--surface-hover)] border border-[var(--border-ui)] hover:border-[#60a5fa]/40 rounded-xl transition-all hover:shadow-[0_0_24px_rgba(96,165,250,0.07)]"
            >
              <div className="text-left">
                <div className="text-[var(--text)] font-semibold mb-0.5">Timed Mode</div>
                <div className="text-[var(--muted-text)] text-sm">150 minutes — full exam conditions</div>
              </div>
              <ArrowRight className="w-4 h-4 text-[var(--subtle-text)] group-hover:text-[#60a5fa] group-hover:translate-x-0.5 transition-all" />
            </button>

            <button
              onClick={() => startExam("untimed")}
              className="group w-full flex items-center justify-between px-6 py-5 bg-[var(--surface-raised)] hover:bg-[var(--surface-hover)] border border-[var(--border-ui)] hover:border-[#60a5fa]/40 rounded-xl transition-all hover:shadow-[0_0_24px_rgba(96,165,250,0.07)]"
            >
              <div className="text-left">
                <div className="text-[var(--text)] font-semibold mb-0.5">Untimed Mode</div>
                <div className="text-[var(--muted-text)] text-sm">No timer — focus on understanding</div>
              </div>
              <ArrowRight className="w-4 h-4 text-[var(--subtle-text)] group-hover:text-[#60a5fa] group-hover:translate-x-0.5 transition-all" />
            </button>
          </div>
        </div>
      </main>

      <footer className="border-t border-[var(--border-ui)] px-6 py-6">
        <p className="text-center text-[var(--subtle-text)] text-xs">© 2025 TMUA Prep. All rights reserved.</p>
      </footer>
    </div>
  );
}
